export default "__VITE_PUBLIC_ASSET__eb619703__"